/**
 * Created by Colin.Watson on 3/2/2015.
 */
(function () {
	'use strict';
	angular
		.module('app')
		.directive('apSquareCheck', function () {
			return {
				restrict: 'E',
				templateUrl: 'app/directives/templates/squareCheck.html',
				scope: {
					disabled: '=',
					field: '@',
					label: '@',
					model: '=',
					options: '=',
					selectedClass: '@',
					tabOrder:'@',
					type: '@'
				},
				transclude: true,
				link: function (scope) {
					if (!scope.selectedClass)
						scope.selectedClass = 'orange';


					scope.cssClass = function () {
						var style = getOptions()[0].style;
						angular.forEach(getOptions(), function (option) {
							if (option.name == scope.model) {
								style = option.style;
							}
						});
						return style + ' ' + scope.selectedClass;
					};

					scope.setState = function () {
						var index = -1;
						angular.forEach(getOptions(), function (option, key) {
							if (option.name == scope.model) {
								index = key;
							}
						});

						if (getOptions().length > index + 1)
							scope.model = getOptions()[index + 1].name;
						else
							scope.model = getOptions()[0].name;

					};

					function getOptions() {
						if (typeof (scope.options) == 'undefined') {
							return [
								{
									name: true,
									style: 'fa-check-square'
								},
								{
									name: false,
									style: 'fa-square-o'
								}
							];
						} else {
							return scope.options;
						}
					}
				}
			};
		});
})();